import type { KeywordCountInput } from "./contracts";

export interface ShanghaiDateContext {
  date: string;
  year: number;
}

export function getShanghaiDateContext(now = new Date()): ShanghaiDateContext {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Shanghai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  const date = `${values.year}-${values.month}-${values.day}`;

  return {
    date,
    year: Number(values.year),
  };
}

export function normalizeKeywordCountForTask(
  input: KeywordCountInput,
  task: string,
  now = new Date()
): KeywordCountInput {
  if (!/(今年|本年|this year)/i.test(task)) {
    return input;
  }

  return {
    ...input,
    year: getShanghaiDateContext(now).year,
  };
}
